export enum TableTypes {
  BOARDS = 'A3 Boards',
  USERS = 'Staff',
  APPLICANTS = 'Applicants',
  STUDENTS = 'Students'
}
